import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "m19.542 20.577-6.28-6.281c-.5.413-1.075.736-1.726.97-.65.233-1.322.35-2.017.35-1.709 0-3.155-.592-4.34-1.776-1.183-1.184-1.775-2.63-1.775-4.338 0-1.71.592-3.156 1.775-4.34 1.184-1.185 2.63-1.777 4.339-1.777 1.708 0 3.155.592 4.34 1.776 1.184 1.183 1.776 2.63 1.776 4.339 0 .714-.12 1.396-.359 2.046a5.72 5.72 0 0 1-.96 1.696l6.281 6.281zM9.52 14.115c1.289 0 2.38-.447 3.274-1.341.895-.894 1.342-1.985 1.342-3.274 0-1.288-.447-2.38-1.342-3.274-.894-.894-1.985-1.341-3.274-1.341-1.288 0-2.38.447-3.274 1.341-.894.894-1.341 1.986-1.341 3.274 0 1.289.447 2.38 1.341 3.274.894.894 1.986 1.342 3.274 1.342ZM7.135 10.25v-1.5h4.769v1.5z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }